import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Box, Flex } from "rebass";
import Cart from "../../icons/Cart";
import { getLocalizedString } from "../../utils";
import config from "../../utils/globalConfig";
import { theme } from "../../utils";
import MiniCart from "../cart/MiniCart";
import "../styles.css";
import { yodaBudgetActions, yodaOrdersActions } from "../../logic/actions";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import OrderMetrics from "../order/OrderMetrics";
import TabButton from "./TabButton";
import useOrderType from "../../hooks/useOrderType";
import useResponsive from "../../hooks/useResponsive";
import { BsColumnsGap } from "react-icons/bs";
import MinicartButton from "./MiniCartButton";

const TabMenu = ({ client }) => {
  const { orderId } = useParams();
  const lang = localStorage.getItem("B2BLanguage") == "ITA" ? "it" : "en";
  const infoRef = useRef();
  const [showMinicart, setShowMinicart] = useState(false);
  const { customer } = useSelector((state) => state.yodaCustomer);
  const { order } = useSelector((state) => state.yodaOrders);
  const { budget } = useSelector((state) => state.yodaBudget);
  const { isDesktopSm } = useResponsive();

  const { isReorderEnabledForOrder, isSwapEnabledForOrder } = useOrderType();
  const navigate = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    if (order)
      dispatch(
        yodaBudgetActions.getBudget(
          order.stakeholderId,
          order.seasonId,
          order.customData?.lineId,
        ),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order]);

  let elements = !client
    ? [
        {
          name: getLocalizedString("I miei ordini"),
          path: "/orders/" + localStorage.getItem("selectedCustomer"),
          visibleOn: [
            "/orders",
            "/neworder",
            "/catalogue",
            "/orderdetail",
            "/orderreport",
          ],
        },
        {
          name: getLocalizedString("Nuovo Ordine"),
          path: "/neworder/" + localStorage.getItem("selectedCustomer"),
          visibleOn: [
            "/orders",
            "/neworder",
            "/catalogue",
            "/orderdetail",
            "/orderreport",
          ],
          condition: () => {
            if (customer?.channelDescription === "Bloccante") return false;
            if (!isReorderEnabledForOrder()) return false;
            if (
              order?.orderType?.id &&
              order?.orderType?.id === config.ORDER_TYPE_SWAP &&
              !isSwapEnabledForOrder()
            )
              return false;
            return true;
          },
        },
        {
          name: getLocalizedString("Ordini in bozza"),
          path: ["/catalogue", "/orderdetail", "/orderreport"],
          visibleOn: ["/catalogue", "/orderdetail", "/orderreport"],
        },
        {
          name: getLocalizedString("Privacy"),
          path: ["/privacy"],
          visibleOn: ["/privacy"],
        },
        {
          name: getLocalizedString("Cookie"),
          path: ["/cookie"],
          visibleOn: ["/cookie"],
        },
        {
          name: getLocalizedString("ADMIN-DRAFT ORDER"),
          path: ["/adminorders"],
          visibleOn: ["/adminorders"],
        },
      ]
    : [
        {
          name: getLocalizedString("Seleziona Cliente"),
          path: "/users",
          visibleOn: ["/users"],
        },
        {
          name: getLocalizedString("Seleziona agente"),
          path: "/agents",
          visibleOn: ["/agents"],
        },
        {
          name: getLocalizedString("Privacy"),
          path: ["/privacy"],
          visibleOn: ["/privacy"],
        },
        {
          name: sessionStorage.getItem("token")
            ? localStorage.getItem("selectedCustomer")
              ? getLocalizedString("BACK TO ORDERS")
              : localStorage.getItem("selectedAgent")
                ? getLocalizedString("BACK TO CUSTOMERS")
                : getLocalizedString("BACK TO ORDERS")
            : getLocalizedString("BACK TO LOGIN"),
          path: sessionStorage.getItem("token")
            ? localStorage.getItem("selectedCustomer")
              ? "/orders/" + localStorage.getItem("selectedCustomer")
              : localStorage.getItem("selectedAgent")
                ? "/users/" + localStorage.getItem("selectedAgent")
                : "/adminOrders"
            : "/",
          visibleOn: ["/privacy"],
        },
        {
          name: getLocalizedString("Cookie"),
          path: ["/cookie"],
          visibleOn: ["/cookie"],
        },
        {
          name: sessionStorage.getItem("token")
            ? localStorage.getItem("selectedCustomer")
              ? getLocalizedString("BACK TO ORDERS")
              : localStorage.getItem("selectedAgent")
                ? getLocalizedString("BACK TO CUSTOMERS")
                : getLocalizedString("BACK TO ORDERS")
            : getLocalizedString("BACK TO LOGIN"),
          path: sessionStorage.getItem("token")
            ? localStorage.getItem("selectedCustomer")
              ? "/orders/" + localStorage.getItem("selectedCustomer")
              : localStorage.getItem("selectedAgent")
                ? "/users/" + localStorage.getItem("selectedAgent")
                : "/adminOrders"
            : "/",
          visibleOn: ["/cookie"],
        },
        {
          name: getLocalizedString("ADMIN-DRAFT ORDER"),
          path: ["/adminOrders"],
          visibleOn: ["/adminOrders"],
        },
      ];

  useEffect(() => {
    if (orderId) dispatch(yodaOrdersActions.getStatusOrder(orderId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  const border = "1px solid #707070";
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  const tab = elements.filter((e) =>
    e.visibleOn.includes("/" + currentPath.split("/")[1]),
  );

  return (
    <Flex
      flex={1}
      width={1}
      height={[40, 50]}
      bg={theme.backgroundSecondary}
      alignItems="flex-end"
      justifyContent="left"
      sx={{ fontWeight: "light" }}
    >
      {/* TABS */}
      {tab.map((element, index) => {
        if (element.condition && !element.condition()) {
          return null;
        }

        const isCurrent = element.path.includes(
          "/" + currentPath.split("/")[1],
        );
        return (
          <Flex
            width={["calc(100%/3)", 120, 160]}
            height={40}
            bg={isCurrent ? theme.white : "none"}
            style={{
              fontFamily: "Open Sans",
              zIndex: 1,
              fontSize: "0.7em",
            }}
            sx={{
              borderBottom: isCurrent ? "none" : border,
              borderTop: ["none", isCurrent ? border : "none"],
              borderLeft: [
                index > 0 ? border : "none",
                isCurrent ? border : "none",
              ],
              borderRight: [
                index < tab.length - 1 ||
                tab.length === 1 ||
                tab.length * 160 < window.innerWidth
                  ? border
                  : "none",
                element.path.includes("/" + currentPath.split("/")[1])
                  ? border
                  : "none",

                element.path.includes("/" + currentPath.split("/")[1])
                  ? border
                  : "none",
              ],
            }}
            alignItems="center"
            justifyContent="center"
            key={index}
          >
            {isCurrent && (
              <Flex width="100%" justifyContent="center">
                {element.name.toUpperCase()}
              </Flex>
            )}

            {!isCurrent && (
              <Link
                style={{
                  textDecoration: "none",
                  color: theme.black,
                  width: 160,
                }}
                to={element.path}
              >
                <Flex minWidth={160} p={3} justifyContent="center">
                  {element.name.toUpperCase()}
                </Flex>
              </Link>
            )}
          </Flex>
        );
      })}
      {/* END - TABS */}
      {/* ROUTE SPECIFIC */}
      <Box
        flex={1}
        height={40}
        justifyContent="left"
        alignItems="center"
        display={["none", , "flex"]}
        sx={{
          borderBottom: border,
        }}
      >
        {(currentPath.includes("draftorders") ||
          currentPath.includes("catalogue") ||
          currentPath.includes("cataloguesettings") ||
          currentPath.includes("orderdetail") ||
          currentPath.includes("orderreport")) && (
          <Flex
            width={"100%"}
            height={"100%"}
            justifyContent="flex-end"
            sx={{
              position: "relative",
            }}
          >
            {(currentPath.includes("draftorders") ||
              currentPath.includes("catalogue") ||
              currentPath.includes("cataloguesettings")) && (
              <>
                <OrderMetrics />
                <MinicartButton />
              </>
            )}
            {((currentPath.includes("orderdetail") &&
              order?.status === "Draft") ||
              (currentPath.includes("orderreport") &&
                order?.status === "Draft")) && (
              <>
                {!currentPath.includes("orderreport") && <OrderMetrics />}
                <TabButton
                  activeIcon={<BsColumnsGap style={{ width: 16 }} />}
                  tooltip={getLocalizedString("CATALOGUE")}
                  onClick={() => {
                    navigate.push("/catalogue/" + order.id);
                  }}
                  sx={{ marginRight: "10px" }}
                />
              </>
            )}
          </Flex>
        )}
        {currentPath.includes("users") && (
          <Flex
            width={"100%"}
            height={"100%"}
            maxWidth={config.VIEWPORT}
            sx={{ fontSize: "12px" }}
            justifyContent="flex-end"
          >
            <Flex
              flexDirection={"row"}
              style={{ fontSize: "0.8em" }}
              alignItems="center"
              ml={2}
              mr={2}
            >
              <Box
                //backgroundColor={"#f5f5f5"}
                backgroundColor={"#dcdcdc"}
                width={14}
                height={14}
                mr={2}
              ></Box>
              {getLocalizedString("Affidabili").toUpperCase()}
            </Flex>

            <Flex
              flexDirection={"row"}
              style={{ fontSize: "0.8em" }}
              alignItems="center"
              ml={2}
              mr={2}
            >
              <Box
                backgroundColor={"#e2ba16"}
                width={14}
                height={14}
                mr={2}
              ></Box>
              {getLocalizedString("Inaffidabili").toUpperCase()}
            </Flex>

            <Flex
              flexDirection={"row"}
              style={{ fontSize: "0.8em", marginRight: "18px" }}
              alignItems="center"
              ml={2}
              mr={2}
            >
              <Box
                backgroundColor={"#f85959"}
                width={14}
                height={14}
                mr={2}
              ></Box>
              {getLocalizedString("Bloccati").toUpperCase()}
            </Flex>
          </Flex>
        )}
      </Box>
      <Box
        flex={1}
        height={40}
        display={["flex", "none"]}
        sx={{
          borderBottom: border,
        }}
      ></Box>
      {/* END - ROUTE SPECIFIC */}
    </Flex>
  );
};

export { TabMenu };
